import { render, staticRenderFns } from "./ProjectAdmin.vue?vue&type=template&id=0e65abe1&scoped=true&"
import script from "./ProjectAdmin.vue?vue&type=script&lang=js&"
export * from "./ProjectAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e65abe1",
  null
  
)

export default component.exports